// extracted by mini-css-extract-plugin
module.exports = {"title":"ArticlesBlok_title__aDFca","head":"ArticlesBlok_head__jZK6T","articleGrid":"ArticlesBlok_articleGrid__Zk6ZQ","card":"ArticlesBlok_card__n0uWJ"};